import React from "react";
import "dayjs/locale/de";
import "dayjs/locale/es";
import "dayjs/locale/fr";
import "dayjs/locale/it";
import "dayjs/locale/pl";
import "dayjs/locale/sk";
import "dayjs/locale/uk";
// inicjalizacja i18n (side-effect import)
import i18n from "./i18n";
import "./i18n";
import { createRoot } from "react-dom/client";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import {
  deDE,
  enUS,
  esES,
  frFR,
  itIT,
  plPL,
  skSK,
  ukUA,
} from "@mui/x-date-pickers/locales";
// 1. Zmień importy: usuń BrowserRouter, dodaj createBrowserRouter i RouterProvider
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import App from "./App";
import { DialogProvider } from "./components/DialogProvider";
import "./index.css";
import { ThemeModeProvider } from "./ThemeContext";
import { installGlobalErrorHandlers } from "./logger";
import { initAnalytics } from "./utils/analytics";
import { normalizeLang } from "./i18n/languages";

installGlobalErrorHandlers();

initAnalytics();

// Set localized meta (description/keywords/og/twitter + canonical + hreflang) for initial language
import { setLocalizedMeta } from "./utils/head";
setLocalizedMeta(i18n.language);
// Update on language change
i18n.on && i18n.on("languageChanged", (lng) => setLocalizedMeta(lng));

// 2. Stwórz router z konfiguracją i flagami "future"
const router = createBrowserRouter(
  [
    {
      // Użyj gwiazdki, aby dopasować wszystkie ścieżki,
      // a komponent <App /> zajmie się resztą routingu wewnątrz siebie.
      path: "*",
      Component: App,
    },
  ],
  {
    // Tutaj dodajesz flagi przyszłości
    future: {
      v7_startTransition: true,
      v7_relativeSplatPath: true,
    },
  },
);

const root = createRoot(document.getElementById("root"));

const pickerLocales = {
  pl: plPL,
  en: enUS,
  uk: ukUA,
  de: deDE,
  it: itIT,
  sk: skSK,
  es: esES,
  fr: frFR,
};

function LocalizedDatePickers({ children }) {
  const [language, setLanguage] = React.useState(() =>
    normalizeLang(i18n.language),
  );

  React.useEffect(() => {
    const handleLanguageChanged = (nextLanguage) =>
      setLanguage(normalizeLang(nextLanguage));
    i18n.on("languageChanged", handleLanguageChanged);
    return () => i18n.off("languageChanged", handleLanguageChanged);
  }, []);

  const locale = pickerLocales[language] || enUS;

  return (
    <LocalizationProvider
      dateAdapter={AdapterDayjs}
      adapterLocale={language}
      localeText={
        locale.components.MuiLocalizationProvider.defaultProps.localeText
      }
    >
      {children}
    </LocalizationProvider>
  );
}

// 3. Zastąp <BrowserRouter> komponentem <RouterProvider> w metodzie render
root.render(
  <React.StrictMode>
    <ThemeModeProvider>
      <DialogProvider>
        <LocalizedDatePickers>
          <RouterProvider
            router={router}
            future={{ v7_startTransition: true, v7_relativeSplatPath: true }}
          />
        </LocalizedDatePickers>
      </DialogProvider>
    </ThemeModeProvider>
  </React.StrictMode>,
);
